import React from 'react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Ripple, initMDB } from 'mdb-ui-kit';

initMDB({ Ripple });

function Footer() {
  return (
    <footer className="text-center bg-body-tertiary" style={{ marginBottom: '-10px'}}>
      <div style={{ backgroundColor: '#162533' }}>
        <div className="container pt-4">
          <section className="mb-2 d-flex flex-column flex-md-row justify-content-between align-items-center">
            {/* Text */}
            <div className="text-center text-md-left text-white mb-2 mb-md-0"style={{ marginTop: '-10px' }}>
              <p style={{ margin: '0' }}>
                © 2024 ISIMM Monastir. All rights reserved.
              </p>
            </div>
            {/* Icons */}
            <div className="d-flex justify-content-center justify-content-md-start" style={{ marginTop: '-10px' }}>

              {/* Facebook */}
              <a
                data-mdb-ripple-init
                className="btn btn-floating m-1 btn-lg rounded-circle"
                href="#!"
                role="button"
                style={{ backgroundColor: '#3b5998' }}
              >
                <i className="fab fa-facebook-f "></i>
              </a>

              {/* Mail */}
              <a
                data-mdb-ripple-init
                className="btn btn-floating m-1 btn-lg rounded-circle"
                href="mailto:your-email@example.com"
                role="button"
                style={{ backgroundColor: '#dd4b39' }}
              >
                <FontAwesomeIcon icon={faEnvelope}  />
              </a>

              {/* Linkedin */}
              <a
                data-mdb-ripple-init
                className="btn btn-floating m-1 btn-lg rounded-circle"
                style={{ backgroundColor: '#0082ca' }}
                href="#!"
                role="button"
              >
                <i className="fab fa-linkedin-in "></i>
              </a>
            </div>
          </section>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
